import React from "react";
import PropTypes from "prop-types";
import { get, chunk } from "lodash";
import { wrapCollectionLayout, LoadMoreCollectionStories } from "@quintype/components";
import BreadCrumb from "../story/story-templates/shared/breadcrumbs";
import { WebEngage, ComScore, DeepBI, Chartbeat, GA, ContentInsights } from "../../../integrations";
import FiveStoriesOneAdBundle from "../../rows/five-stories-one-ad-bundle";
import NineteenStoriesOneAd from "../../rows/nineteen-stories-one-ad";
import { LoadMoreButton } from "../../atoms/read-more-link";
import { DfpAd } from "../../atoms/dfp-ad";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
const LOAD_MORE_TEXT = "மேலும் படிக்க";

const wrapForLoadMore = (Component, numberOfStoriesItCanAccomodate) => {
  const WrapperForLoadMore = ({ stories, collection, onLoadMore, noMoreStories, loading }) => {
    return (
      <React.Fragment>
        {chunk(stories.slice(5), numberOfStoriesItCanAccomodate).map((stories, index) => {
          const items = stories.map(story => {
            return { id: story.id, type: "story", story };
          });
          return <Component key={index} collection={{ ...collection, items }} />;
        })}
        {!noMoreStories && (
          <div className={styles["load-more-button-wrapper"]}>
            <LoadMoreButton onClick={onLoadMore} disabled={loading} text={LOAD_MORE_TEXT} />
          </div>
        )}
      </React.Fragment>
    );
  };
  WrapperForLoadMore.propTypes = {
    stories: PropTypes.array,
    collection: PropTypes.object,
    onLoadMore: PropTypes.func,
    noMoreStories: PropTypes.func,
    loading: PropTypes.bool
  };
  return WrapperForLoadMore;
};

const BundlePage = ({ data, config }) => {
  const initialStories = get(data, ["collection", "items"], []).filter(items => items.type === "story");
  const WrappedFiveStoriesOneAdBundle = wrapCollectionLayout(FiveStoriesOneAdBundle);
  React.useEffect(() => {
    WebEngage.registerPageView();
    ComScore.registerPageView();
    DeepBI.loadScript();
    Chartbeat.registerNonStoryPageView(PAGE_TYPE.BUNDLE_PAGE, { collection: data.collection });
    GA.registerPageView(PAGE_TYPE.BUNDLE_PAGE, { collection: data.collection });
    ContentInsights.registerNonStoryPageView(config.contentInsightsId, PAGE_TYPE.BUNDLE_PAGE, {
      collection: data.collection
    });
  }, []);
  return (
    <div className={`main-page ${styles["default-section-page-container"]}`}>
      <DfpAd className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
      <div className={styles["default-section-page"]}>
        <div className="container">
          <BreadCrumb config={config} collection={data.collection} />
        </div>
        <WrappedFiveStoriesOneAdBundle collection={{ ...data.collection, items: initialStories.slice(0, 5) }} />
        <LoadMoreCollectionStories
          template={wrapForLoadMore(NineteenStoriesOneAd, 19)}
          collectionSlug={data.collection.slug}
          data={Object.assign(
            {},
            { collection: data.collection },
            { stories: [...initialStories.map(({ story }) => story).slice(0, 5)] },
            { storiesPerPage: 19 }
          )}
          numStoriesToLoad={19}
          params={{ "item-type": "story" }}
        />
        <DfpAd adtype="Leaderboard" placement="bundle" />
      </div>
      <DfpAd className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
    </div>
  );
};

export { BundlePage };

BundlePage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  })
};

export default BundlePage;
